























































































































import Vue from "vue"
import { Office } from "@/model/entity/office/office"
import OfficeBasicInfo from "@/components/user-administration/OfficeBasicInfo.vue"
import OfficeOther from "@/components/user-administration/OfficeOther.vue"
import OfficeRange from "@/components/user-administration/OfficeRange.vue"
import OfficeEmployees from "@/components/user-administration/OfficeEmployees.vue"
import OfficeReturnAddress from "@/components/user-administration/OfficeReturnAddress.vue"
import { Employee } from "@/model/entity/employee/employee"
import { countryList } from "@/model/service/country/country-service"
import { Country } from "@/model/entity/country/country"
import { ShipmentReturn } from "@/model/entity/shipment/shipment-return"

export interface IOfficeEditor extends Vue, Data {}

interface Data {
  countryList: Country[]
  editedOffice: Office | null
  basicInfoFormValid: boolean
  addressFormValid: boolean
  otherFormValid: boolean
}

export default Vue.extend({
  data(): Data {
    return {
      countryList: countryList,
      editedOffice: null,
      basicInfoFormValid: false,
      addressFormValid: false,
      otherFormValid: false
    }
  },
  components: {
    OfficeBasicInfo,
    OfficeOther,
    OfficeRange,
    OfficeEmployees,
    OfficeReturnAddress
  },
  props: {
    office: {
      type: Object as () => Office,
      default: () => new Office()
    },
    isAdd: {
      type: Boolean,
      default: false
    },
    formsValid: {
      type: Boolean,
      default: false
    },
    employees: {
      type: Array as () => Employee[],
      default: () => {
        return []
      }
    },
    pageFormats: {
      required: true,
      default: []
    },
    charsets: {
      required: true,
      default: []
    }
  },
  methods: {
    saveOffice() {
      this.$emit("save", this.editedOffice)
      if (this.isAdd) {
        this.editedOffice = JSON.parse(JSON.stringify(new Office()))
        this.setOfficeDefaults()
      }
    },
    validateOfficeForms() {
      this.$emit("update:forms-valid", this.basicInfoFormValid && this.otherFormValid)
    },
    setOfficeDefaults() {
      this.editedOffice!.country = this.countryList.find(
        country => country.isoCodeAlpha2 === this.$store.getters.domesticCountryIso
      )
      this.editedOffice!.businessUnit = this.$store.getters.businessUnitCode
      this.editedOffice!.homeDepot = this.$store.getters.depots[0]
    },
     resetReturnAddressForm() {
      this.editedOffice.shipmentReturn = new ShipmentReturn()
    }
  },
  watch: {
    editedOffice: {
      deep: true,
      handler() {
        this.$nextTick(() => this.validateOfficeForms())
      }
    }
  },
  created() {
    if (!this.office.shipmentReturn) {
      this.office.shipmentReturn = new ShipmentReturn()
    }
    this.editedOffice = JSON.parse(JSON.stringify(this.office))
    if (!exists(this.editedOffice!.id)) {
      this.setOfficeDefaults()
    }
  }
})
